<template>
  <div id="app">
    <SiteHeader />
    <div class="main-content">
      <router-view />
    </div>
    <SiteFooter />
  </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader'
import SiteFooter from '@/components/SiteFooter'

export default {
  name: 'App',
  components: { SiteHeader, SiteFooter }
}
</script>

<style>
* { margin: 0; padding: 0; box-sizing: border-box; }
body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  background: #f0f2f8;
  color: #1a1f36;
  -webkit-font-smoothing: antialiased;
}
.main-content { min-height: calc(100vh - 64px - 60px); }
a { text-decoration: none; color: inherit; }

/* 全局滚动条 */
::-webkit-scrollbar { width: 6px; height: 6px; }
::-webkit-scrollbar-track { background: transparent; }
::-webkit-scrollbar-thumb { background: #c0c4cc; border-radius: 3px; }
::-webkit-scrollbar-thumb:hover { background: #909399; }
</style>
